import React, { useEffect, useState } from 'react'
import { useChangeWebNotificationStateMutation, useGetWebNotificationsQuery } from '../../store/webNotifications/webNotifications'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { WebNotification } from '../../models/Notification'
import { Col, Row } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import buttonStyles from '../Button/Button.module.scss'
import { Button } from '../Button/Button'

const _SEVERITY_MAPPING = {
  info: { background: 'zocks-bg-color-primary-light', icon: 'bi-info-circle-fill', iconColor: 'zocks-text-primary' },
  warning: { background: 'zocks-bg-color-warning', icon: 'bi-exclamation-triangle-fill', iconColor: 'zocks-text-warning-text' },
  error: { background: 'zocks-bg-color-danger-background', icon: 'bi-exclamation-circle-fill', iconColor: 'zocks-text-danger' },
}

export const WebNotificationBanner: React.FC = () => {
  const accountId = useAppSelector(selectAccountId)

  const { data: webNotifications } = useGetWebNotificationsQuery(
    { accountId },
    { refetchOnMountOrArgChange: true, pollingInterval: 30000, skipPollingIfUnfocused: true },
  )

  const [triggerChangeWebNotificationState, { isLoading: dismissLoading }] = useChangeWebNotificationStateMutation()

  const [displayedNotification, setDisplayedNotification] = useState<WebNotification | null>(null)

  useEffect(() => {
    if (!webNotifications?.data.length) {
      return
    }
    setDisplayedNotification(webNotifications.data[0])
  }, [webNotifications])

  if (!displayedNotification) {
    return null
  }

  const dismissNotification = async () => {
    await triggerChangeWebNotificationState({ accountId, webNotificationId: displayedNotification.id, newState: 'dismissed' })
    setDisplayedNotification(null)
  }

  const {
    content: { message, links, severity = 'info' },
  } = displayedNotification

  const { background, icon, iconColor } = _SEVERITY_MAPPING[severity] ?? _SEVERITY_MAPPING['info']

  return (
    <Row className={`${background} zocks-text-gray-900 pt-2 pb-2 header-banner`}>
      <Col className='d-flex'>
        <div className='d-flex gap-2 align-items-center justify-content-center flex-grow-1 px-3'>
          <i className={`bi ${icon} ${iconColor}`} />
          <div className='text-center'>{message}</div>

          {links
            ? Object.entries(links).map(([label, to]) => {
                return (
                  <NavLink key={to} className={`${buttonStyles.button} ${buttonStyles.linkButton} button-link-medium`} to={to}>
                    {label}
                  </NavLink>
                )
              })
            : null}
        </div>
        <div className={`${background} ms-auto`}>
          <Button variant='borderless' className={`${background}`} onClick={dismissNotification} loading={dismissLoading}>
            <i className='bi bi-x' />
          </Button>
        </div>
      </Col>
    </Row>
  )
}
